"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var theme_get_1 = require("@styled-system/theme-get");
var css_1 = __importDefault(require("@styled-system/css"));
var camelCase = function (input) {
    return input.toLowerCase().replace(/-(.)/g, function (match, group1) { return group1.toUpperCase(); });
};
// a getter to access theme items
// you can use it to get 1 value > get('fontSizes.3'); or both css prop:val > get('font-size', 3);
var get = function (themeKey, optThemeValue) { return function (props) {
    var _a;
    // nominal case for when you pass both args
    if (themeKey && optThemeValue !== null && optThemeValue !== undefined) {
        var normalizedThemeKey = camelCase(themeKey);
        return css_1.default((_a = {},
            _a[normalizedThemeKey] = optThemeValue,
            _a));
    }
    return theme_get_1.themeGet(themeKey)(props);
}; };
exports.default = get;
